export const GA_TRACKING_ID = 'UA-116295967-1';